export default __webpack_public_path__ + "static/media/chaeyoung.b7303fca.jpg";